import { getVesselLimits, getConsignmentLimits, addVesselLimits, addConsignmentLimits } from '../utils/apiService';

export const CREATE_LIMIT = 'limit/CREATE_LIMIT';
export const CREATE_LIMIT_PENDING = 'limit/CREATE_LIMIT_PENDING';
export const CREATE_LIMIT_FULFILLED = 'limit/CREATE_LIMIT_FULFILLED';
export const CREATE_LIMIT_REJECTED = 'limit/CREATE_LIMIT_REJECTED';

export const LIST_VESSEL_LIMITS = 'limit/LIST_VESSEL_LIMITS';
export const LIST_VESSEL_LIMITS_PENDING = 'limit/LIST_VESSEL_LIMITS_PENDING';
export const LIST_VESSEL_LIMITS_REJECTED = 'limit/LIST_VESSEL_LIMITS_REJECTED';
export const LIST_VESSEL_LIMITS_FULFILLED = 'limit/LIST_VESSEL_LIMITS_FULFILLED';

export const LIST_CONSIGNMENT_LIMITS = 'limit/LIST_CONSIGNMENT_LIMITS';
export const LIST_CONSIGNMENT_LIMITS_PENDING = 'limit/LIST_CONSIGNMENT_LIMITS_PENDING';
export const LIST_CONSIGNMENT_LIMITS_REJECTED = 'limit/LIST_CONSIGNMENT_LIMITS_REJECTED';
export const LIST_CONSIGNMENT_LIMITS_FULFILLED = 'limit/LIST_CONSIGNMENT_LIMITS_FULFILLED';

export const CREATE_VESSEL_LIMIT = 'limit/CREATE_VESSEL_LIMIT';
export const CREATE_VESSEL_LIMIT_PENDING = 'limit/CREATE_VESSEL_LIMIT_PENDING';
export const CREATE_VESSEL_LIMIT_FULFILLED = 'limit/CREATE_VESSEL_LIMIT_FULFILLED';
export const CREATE_VESSEL_LIMIT_REJECTED = 'limit/CREATE_VESSEL_LIMIT_REJECTED';

export const CREATE_CONSIGNMENT_LIMIT = 'limit/CREATE_CONSIGNMENT_LIMIT';
export const CREATE_CONSIGNMENT_LIMIT_PENDING = 'limit/CREATE_CONSIGNMENT_LIMIT_PENDING';
export const CREATE_CONSIGNMENT_LIMIT_FULFILLED = 'limit/CREATE_CONSIGNMENT_LIMIT_FULFILLED';
export const CREATE_CONSIGNMENT_LIMIT_REJECTED = 'limit/CREATE_CONSIGNMENT_LIMIT_REJECTED';

export const UPDATE_VESSEL_LIMITS = 'limit/UPDATE_VESSEL_LIMITS';
export const UPDATE_VESSEL_LIMITS_PENDING = 'limit/UPDATE_VESSEL_LIMITS_PENDING';
export const UPDATE_VESSEL_LIMITS_FULFILLED = 'limit/UPDATE_VESSEL_LIMITS_FULFILLED';
export const UPDATE_VESSEL_LIMITS_REJECTED = 'limit/UPDATE_VESSEL_LIMITS_REJECTED';

export const UPDATE_CONSIGNMENT_LIMITS = 'limit/UPDATE_CONSIGNMENT_LIMITS';
export const UPDATE_CONSIGNMENT_LIMITS_PENDING = 'limit/UPDATE_CONSIGNMENT_LIMITS_PENDING';
export const UPDATE_CONSIGNMENT_LIMITS_REJECTED = 'limit/UPDATE_CONSIGNMENT_LIMITS_REJECTED';
export const UPDATE_CONSIGNMENT_LIMITS_FULFILLED = 'limit/UPDATE_CONSIGNMENT_LIMITS_FULFILLED';


export const listVesselLimits = (insurer) => {
    const payload = getVesselLimits(insurer);
    return {
        type: LIST_VESSEL_LIMITS,
        payload
    }
}

export const updateVesselLimits = (limit) => {
    const payload = addVesselLimits(limit);
    return {
        type: UPDATE_VESSEL_LIMITS,
        payload
    }
}

export const listConsignmentLimits = (insurer) => {
    const payload = getConsignmentLimits(insurer);
    return {
        type: LIST_CONSIGNMENT_LIMITS,
        payload
    }
}

export const updateConsignmentLimits = (limit) => {
    const payload = addConsignmentLimits(limit);
    return {
        type: UPDATE_CONSIGNMENT_LIMITS,
        payload
    }
}


// WEBPACK FOOTER //
// ./src/actions/limits.js